"use client"

import { useEffect } from "react"
import { toast } from "sonner"

import { REJECTED_SIGNUP_CODE_MESSAGE, takeRejectedSignupCode } from "@/lib/partners/rejected-signup-code"

/** Tells a merchant back from Stripe Checkout that the partner code typed at signup was not applied. */
export function RejectedSignupCodeToast() {
  useEffect(() => {
    if (takeRejectedSignupCode()) toast.warning(REJECTED_SIGNUP_CODE_MESSAGE, { duration: 10_000 })
  }, [])
  return null
}
